import { render, staticRenderFns } from "./RegistroCompleto.vue?vue&type=template&id=56516366&"
import script from "./RegistroCompleto.vue?vue&type=script&lang=js&"
export * from "./RegistroCompleto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports